import React from "react";
import { Modal } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { DeletedRecord } from "redux/actions/Common";
import { DataRequestActionAPI } from "../../redux/actions/http";
const { confirm } = Modal;
const ROOT_URL = process.env.REACT_APP_ROOT_URL;

const DeleteConfirmNew = ({
  title,
  content,
  buttonName,
  selectedItem,
  type,
  api,
  Icon,
  method = "DELETE",
  okText = "Delete",
  loading = "Nothing",
}) => {
  console.log("selectedItem", selectedItem);
  const dispatch = useDispatch();

  const { inventorySpinner, inventoryError, inventorySuccess } = useSelector(
    (state) => state.inventory
  );

  const showDeleteConfirm = () => {
    confirm({
      title: title,
      icon: <QuestionCircleOutlined />,
      content: content,
      okText: okText,
      okType: "primary",
      cancelText: "Cancel",
      confirmLoading: true,

      onOk() {
        return new Promise((resolve, reject) => {
          console.log("selectedItem", selectedItem);
          // const token = localStorage.getItem('token');
          // fetch(`${ROOT_URL}/${type}`, {
          //     method: method,
          //     headers: new Headers({
          //         "Content-Type": "application/json",
          //         'Authorization': token,
          //         'APIType':"web"
          //     }),
          //     body: JSON.stringify(selectedItem)
          // }).then((response) => {
          //     response.json().then((response) => {
          //         console.log('deleteRoles type', type,response);
          //         dispatch(DeletedRecord(type, response))
          //         resolve();
          //     })
          // }).catch(err => {
          //     reject();
          // })

          dispatch(
            DataRequestActionAPI(
              method,
              api,
              type,
              selectedItem,
              "",
              loading,
              true
            )
          );

          if (inventorySuccess) {
            resolve();
          } else {
            reject();
          }
        }).catch(() => console.log("Oops errors!"));
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  return (
    <span
      className=" gx-pointer deleteButton"
      style={{ fontSize: "20px" }}
      onClick={showDeleteConfirm}
    >
      {" "}
      {Icon ? Icon : buttonName}{" "}
    </span>
  );
};

export default DeleteConfirmNew;
